import analytics from '@repo/analytics';
import Select from '@repo/editor/src/components/SelectNew/Select';
import { withEventScope } from '@repo/event-processor';

import { FILTERS_PREFIX } from 'global/analyticsEvents';
import { getTagsByGroup } from 'global/utils/templates/getTagsByGroup';

import { Wrapper } from './styles';
import { FiltersSectionProps } from './type';

const FiltersSection: React.FC<FiltersSectionProps> = ({
  tagGroups,
  filters,
  setFilters,
}) => {
  const colorsTags = getTagsByGroup('colors', tagGroups);
  const themesTags = getTagsByGroup('themes', tagGroups);
  const stylesTags = getTagsByGroup('styles', tagGroups);

  const onFilterChange = (
    filter: string,
    tag: { id: string | number; label: string }
  ) => {
    void analytics.track(FILTERS_PREFIX + ':' + filter, { option: tag });
    setFilters({
      ...filters,
      [filter]: tag,
    });
  };

  return (
    <Wrapper>
      <Select
        small
        activeOption={filters.colors || colorsTags[0]}
        dataTestId="design-posts--colors-select"
        options={colorsTags}
        onSelect={(tag) => onFilterChange('colors', tag)}
      />
      <Select
        small
        activeOption={filters.themes || themesTags[0]}
        dataTestId="design-posts--themes-select"
        options={themesTags}
        placeholder="All themes"
        onSelect={(tag) => onFilterChange('themes', tag)}
      />
      <Select
        small
        activeOption={filters.styles || stylesTags[0]}
        dataTestId="design-posts--styles-select"
        options={stylesTags}
        placeholder="All styles"
        onSelect={(tag) => onFilterChange('styles', tag)}
      />
    </Wrapper>
  );
};

export default withEventScope(FiltersSection, { feature: 'filtersSection' });
